import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import type { Sector } from '../lib/types';

let cachedSectors: Sector[] | null = null;
let cachePromise: Promise<Sector[]> | null = null;

async function fetchSectors(): Promise<Sector[]> {
  if (cachedSectors) return cachedSectors;
  if (cachePromise) return cachePromise;
  cachePromise = (async () => {
    try {
      const { data, error } = await supabase
        .from('sectors')
        .select('id, slug, label, sort_order, created_at')
        .order('sort_order');
      if (error) throw error;
      cachedSectors = data ?? [];
      return cachedSectors;
    } catch (err) {
      cachePromise = null;
      throw err;
    }
  })();
  return cachePromise;
}

export function useSectors() {
  const [sectors, setSectors] = useState<Sector[]>(cachedSectors ?? []);
  const [loading, setLoading] = useState(!cachedSectors);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (cachedSectors) {
      setSectors(cachedSectors);
      setLoading(false);
      return;
    }
    fetchSectors()
      .then((data) => setSectors(data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return { sectors, loading, error };
}
